import React, { useState, useEffect } from 'react';
import { Card, Button, Badge, PageHeader } from '../../components/ui';
import api from '../../services/api';

export default function ABTesting() {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchTests(); }, []);

  const fetchTests = async () => {
    try { const r = await api.get('/campaigns'); setTests((r.data.data || []).filter(c => c.isAbTest)); }
    catch {} finally { setLoading(false); }
  };

  return (
    <div>
      <PageHeader title="A/B Testing" subtitle="Compare campaign variations and pick winners" />
      {loading ? <div style={{ color:'#555', textAlign:'center', padding:40 }}>Loading...</div> : (
        tests.length === 0 ? (
          <Card style={{ textAlign: 'center', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🧪</div>
            <h3 style={{ color: '#ccc', marginBottom: 8 }}>No A/B tests yet</h3>
            <p style={{ color: '#555', fontSize: 14, maxWidth: 420, margin: '0 auto' }}>Create a campaign with type "A/B Test" to split-test subject lines and email bodies. Auto-winner is selected after your chosen time window.</p>
          </Card>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {tests.map(t => (
              <Card key={t.id}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{t.name}</div>
                    <div style={{ fontSize: 12, color: '#555' }}>Split: {t.abSplitPercent}% A / {100 - t.abSplitPercent}% B · Winner by: {t.abWinnerMetric?.replace('_', ' ')} after {t.abWinnerAfterHours}h</div>
                  </div>
                  <Badge color={t.abWinner ? 'success' : 'info'}>{t.abWinner ? `Winner: Version ${t.abWinner.toUpperCase()}` : 'Running'}</Badge>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  {['a','b'].map(v => (
                    <div key={v} style={{ background: '#1a1a1a', borderRadius: 10, padding: 14, border: `1px solid ${t.abWinner === v ? '#2ECC71' : 'rgba(255,255,255,0.06)'}` }}>
                      <div style={{ fontWeight: 800, color: t.abWinner === v ? '#2ECC71' : '#fff', marginBottom: 8, fontSize: 13 }}>Version {v.toUpperCase()} {t.abWinner === v ? '🏆' : ''}</div>
                      <div style={{ fontSize: 12, color: '#666' }}>{v === 'a' ? t.abVersionA?.subject || 'No subject set' : t.abVersionB?.subject || 'No subject set'}</div>
                    </div>
                  ))}
                </div>
              </Card>
            ))}
          </div>
        )
      )}
    </div>
  );
}
